// 为了方便换算
// 750px 设计稿，1rem = 75px
const resize = () => {
  const html = document.documentElement;
  const wW = html.clientWidth; // 窗口宽度
  if (wW < 1200) {
    // pc端内容宽度为1200px
    // 移动端：750px 设计稿，1rem = 75px
    const rem = (wW / 750) * 75;
    html.style.fontSize = `${rem}px`;
  } else {
    html.style.fontSize = '12px';
  }
};
resize();
window.addEventListener('resize', resize, false);
